// frontend/src/admin/AdminLayout.jsx

import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../pages/admin/Admin.css';

const AdminLayout = () => {
    // FIX: was `logout` — AuthContext exposes `signOut`, not `logout`
    const { signOut } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        signOut();
        navigate('/admin/login');
    };

    const navItems = [
        { path: '/admin', label: '📊 Dashboard' },
        { path: '/admin/products', label: '👗 Product CRM' },
        { path: '/admin/orders', label: '📦 Orders' },
        { path: '/admin/announcements', label: '📢 Announcements' },
        { path: '/admin/settings', label: '⚙️ Portal Settings' },
    ];

    // FIX: was `location.pathname === item.path` — exact match fails for
    // sub-paths. Now uses startsWith with a special case for /admin root
    // so Dashboard only highlights when exactly on /admin.
    const isActive = (itemPath) => {
        if (itemPath === '/admin') {
            return location.pathname === '/admin';
        }
        return location.pathname.startsWith(itemPath);
    };

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <h2>Raajdhani</h2>
                    <p style={{
                        margin: '4px 0 0',
                        fontSize: '0.65rem',
                        letterSpacing: '2px',
                        textTransform: 'uppercase',
                        color: 'rgba(255,255,255,0.5)'
                    }}>
                        Admin Portal
                    </p>
                </div>

                <nav className="admin-nav">
                    {navItems.map(item => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={isActive(item.path) ? 'active' : ''}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>

                <button onClick={handleLogout} className="logout-btn">
                    🚪 Sign Out
                </button>
            </aside>

            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
